__turbopack_context__.v({
  "buttons": "Pricing-module__WqC_RG__buttons",
  "community": "Pricing-module__WqC_RG__community",
  "containers": "Pricing-module__WqC_RG__containers",
  "description": "Pricing-module__WqC_RG__description",
  "enterprise": "Pricing-module__WqC_RG__enterprise",
  "heading": "Pricing-module__WqC_RG__heading",
  "inside": "Pricing-module__WqC_RG__inside",
  "period": "Pricing-module__WqC_RG__period",
  "price": "Pricing-module__WqC_RG__price",
  "priceContainer": "Pricing-module__WqC_RG__priceContainer",
  "professional": "Pricing-module__WqC_RG__professional",
  "subtitle": "Pricing-module__WqC_RG__subtitle",
  "wrapper": "Pricing-module__WqC_RG__wrapper",
});
